import DgApiSelect from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgApiSelect.install = function (Vue) {
  Vue.component(DgApiSelect.name, DgApiSelect)
}
export default DgApiSelect

export { DgApiSelect }